import * as React from 'react';
import { Link } from 'react-router-dom';

import { UitkSelect } from 'uitk-react-select';
import { UitkTextInput } from 'uitk-react-input';

export interface PhgParametersProps {
  onCamRefChange(event: any): void;
  camref: string;
  onAdRefChange(event: any): void;
  adRef: string;
  onCreativerefChange(event: any): void;
  creativeRef: string;
  onPubRefChange(event: any): void;
  pubRef: string;
}

export class PhgParameters extends React.Component<PhgParametersProps> {
  public constructor(props) {
    super(props);
  }

  public render() {
    const {
      onCamRefChange,
      camref,
      onAdRefChange,
      adRef,
      onCreativerefChange,
      creativeRef,
      onPubRefChange,
      pubRef,
    } = this.props;

    return (
      <>
        <div className="uitk-grid all-b-margin-three">
          <div className="uitk-cell s-cell-1-1 m-cell-1-3 l-cell-1-4 xl-cell-1-4">
            <UitkTextInput
              label="Input the value for camref"
              name="camref"
              onChange={onCamRefChange}
              placeholder="camref"
              value={camref}
            />
          </div>
        </div>
        <div className="uitk-grid all-b-margin-three">
          <div className="uitk-cell s-cell-1-1 m-cell-1-3 l-cell-1-4 xl-cell-1-4">
            <UitkTextInput
              label="Input the value for adref"
              name="adref"
              onChange={onAdRefChange}
              placeholder="adref"
              value={adRef}
            />
          </div>
        </div>
        <div className="uitk-grid all-b-margin-three">
          <div className="uitk-cell s-cell-1-1 m-cell-1-3 l-cell-1-4 xl-cell-1-4">
            <UitkTextInput
              label="Input the value for creativeref"
              name="creativeref"
              onChange={onCreativerefChange}
              placeholder="creativeref"
              value={creativeRef}
            />
          </div>
        </div>
        <div className="uitk-grid all-b-margin-three">
          <div className="uitk-cell s-cell-1-1 m-cell-1-3 l-cell-1-4 xl-cell-1-4">
            <UitkTextInput
              label="Input the value for pubref"
              name="pubref"
              onChange={onPubRefChange}
              placeholder="pubref"
              value={pubRef}
            />
          </div>
        </div>
      </>
    );
  }
}
